"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var background_svg_1 = __importDefault(require("./background.svg"));
function PopInMenu(_a) {
    var menuItems = _a.menuItems, selectedMenu = _a.selectedMenu, onChange = _a.onChange, height = _a.height;
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
            borderStyle: 'solid',
            borderColor: 'secondary.light',
            borderWidth: '0px',
            borderRightWidth: '1px',
            paddingTop: '36px',
            width: {
                xs: '240px',
                // xl: '355px',
            },
            height: height,
        } }, { children: [(height || '0px').split('px')[0] > '450' && ((0, jsx_runtime_1.jsx)(material_1.Box, { component: "img", sx: {
                    width: '240px',
                    height: height,
                }, src: background_svg_1.default })), (0, jsx_runtime_1.jsx)(material_1.Tabs, __assign({ orientation: "vertical", variant: "scrollable", value: selectedMenu, onChange: onChange, "aria-label": "Vertical PopInMenu", sx: {
                    marginTop: "-".concat(((height || '0px').split('px')[0] > '450' ? height : '0px') || '0px'),
                    height: height,
                    '& .MuiTabs-indicator': {
                        backgroundColor: 'text.secondary',
                        width: {
                            xs: '220px',
                            // xl: '240px',
                        },
                        zIndex: 2,
                        borderRadius: '50px 0px 0px 50px',
                    },
                } }, { children: menuItems.map(function (item) {
                    return ((0, jsx_runtime_1.jsx)(material_1.Tab, { disableRipple: true, label: item.label, id: "popinitem".concat(item.value), sx: {
                            color: 'text.primary',
                            textTransform: 'none',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            zIndex: 3,
                            '&.Mui-selected': {
                                color: 'background.default',
                                fontWeight: 'bold',
                            },
                            minHeight: '48px',
                        }, disabled: item.disabled, icon: item.iconEnd, iconPosition: "end" }, "popinitem".concat(item.value)));
                }) }))] })));
}
exports.default = PopInMenu;
PopInMenu.defaultProps = {
    height: '500px',
};
//# sourceMappingURL=PopInMenu.js.map